import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Help = React.lazy(() => import("@mediaspace/features/help-page"));

export const render = getDsLayoutComponentRenderer(Help);
